/**
 * @flow
 */
'use strict';

export const medicationStrengthCodes = [
  {"code":"5 mg"},
  {"code":"10 mg"},
  {"code":"20 mg"},
  {"code":"30 mg"},
  {"code":"50 mg"},
  {"code":"100 mg"},
  {"code":"200 mg"}
]

export const medicationDosageCodes = [
  {"code":"1 gtt"},
  {"code":"2 gtt"},
  {"code":"3 gtt"},
  {"code":"5 gtt"},
  {"code":"1 capsule"},
  {"code":"2 capsules"},
  {"code":"1 tablespoon"}
]

export const medicationDurationCodes = [
  {"code":"1 day"},
  {"code":"2 days"},
  {"code":"3 days"},
  {"code":"4 days"},
  {"code":"1 week"},
  {"code":"2 weeks"},
  {"code":"1 month"},
  {"code":"2 months"},
  {"code":"1 year"}
]

export const medicationInstructionCodes = [
  {"code":"Take before food"},
  {"code":"Take after food"},
  {"code":"Shake well before use"}
]

export const medicationRefillCodes = [
  {"code":"No refill"},
  {"code":"Refill 1x"},
  {"code":"Refill 2x"},
  {"code":"Refill 3x"},
  {"code":"Refill 4x"},
  {"code":"Refill 5x"},
  {"code":"Refill 6x"},
  {"code":"Refill 7x"},
  {"code":"Refill 8x"},
  {"code":"Refill 9x"},
  {"code":"Refill 10x"},
  {"code":"Refill 11x"},
  {"code":"Refill 12x"}
]

export const medicationCodes = [
  {"code":"Abilify"},
  {"code":"Accupril"},
  {"code":"Accuretic"},
  {"code":"Accutane"},
  {"code":"Acebutolol"},
  {"code":"Acetaminophen"},
  {"code":"Acetioprim"},
  {"code":"Aclasta"},
  {"code":"Actonel"},
  {"code":"Actos"},
  {"code":"Adalat"},
  {"code":"Adderall"},
  {"code":"Advair"},
  {"code":"Advil"},
  {"code":"Aerius"},
  {"code":"Aggrenox"},
  {"code":"Aldactone"},
  {"code":"Alendronate"},
  {"code":"Alertec"},
  {"code":"Alesse"},
  {"code":"Alfuzosin"},
  {"code":"Aling"},
  {"code":"Allegra"},
  {"code":"Allopurinol"},
  {"code":"Almotech"},
  {"code":"Alopurinol"},
  {"code":"Alprazolam"},
  {"code":"Altace"},
  {"code":"Alvesco"},
  {"code":"Amantatine"},
  {"code":"Amarel"},
  {"code":"Amerge"},
  {"code":"Amiodarone"},
  {"code":"Amitriptyline"},
  {"code":"Amlodipine"},
  {"code":"Anaprox"},
  {"code":"Anastrozole"},
  {"code":"Andriol"},
  {"code":"Androgel"},
  {"code":"Angelic"},
  {"code":"Anovulant"},
  {"code":"Pain killer"},
  {"code":"Anti-histamine"},
  {"code":"Anti-inflammatory"},
  {"code":"Anti-psychotic"},
  {"code":"Antibiotic"},
  {"code":"Anticoagulant"},
  {"code":"Anti depressive"},
  {"code":"Apo-esomeprazole"},
  {"code":"Apo-gliclazide"},
  {"code":"Apo-hydro"},
  {"code":"Apo-mometasone"},
  {"code":"Apo-omeprazole"},
  {"code":"Apo-oxazepam"},
  {"code":"Apo-pindol"},
  {"code":"Apo-quinapril"},
  {"code":"Apo-salvent"},
  {"code":"Apo-triazide"},
  {"code":"Apo-fluconazole"},
  {"code":"Apo-fosinopril"},
  {"code":"Apohydroxyzine"},
  {"code":"Apometropolol"},
  {"code":"Apprilum"},
  {"code":"Apranax"},
  {"code":"Aprilon"},
  {"code":"Aredia"},
  {"code":"Aricept"},
  {"code":"Arimidex"},
  {"code":"Arthrotec"},
  {"code":"Asacol"},
  {"code":"Asaphen"},
  {"code":"Asatab"},
  {"code":"Aspicor"},
  {"code":"Aspirin"},
  {"code":"Atacan"},
  {"code":"Atarax"},
  {"code":"Atenolol"},
  {"code":"Ativan"},
  {"code":"Atorvastatin"},
  {"code":"Atripla"},
  {"code":"Atrovent"},
  {"code":"Aubagio"},
  {"code":"Auro citalopram"},
  {"code":"Auro quetiapine"},
  {"code":"Avalide"},
  {"code":"Avamys"},
  {"code":"Avandia"},
  {"code":"Avapro"},
  {"code":"Avastatin"},
  {"code":"Aventyl"},
  {"code":"Avodart"},
  {"code":"Avonex"},
  {"code":"Axert"},
  {"code":"Azathioprine"},
  {"code":"Azilect"},
  {"code":"Azithromycin"},
  {"code":"Baclofen"},
  {"code":"Benadryl"},
  {"code":"Benzodiazepine"},
  {"code":"Betaceron"},
  {"code":"Betaderm"},
  {"code":"Biaxin"},
  {"code":"Bifantin"},
  {"code":"Biocal"},
  {"code":"Biphentin"},
  {"code":"Bisoprolol"},
  {"code":"Bitosa"},
  {"code":"Botox"},
  {"code":"Breezhaler"},
  {"code":"Bricanyl"},
  {"code":"Bromocriptine"},
  {"code":"Buscopan"},
  {"code":"Butrans"},
  {"code":"C-pack"},
  {"code":"Ca+/vit.D"},
  {"code":"Caduet"},
  {"code":"Calcia"},
  {"code":"Calcite"},
  {"code":"Calcitonine"},
  {"code":"Calcium"},
  {"code":"Caltrate"},
  {"code":"Cambian"},
  {"code":"Candesartan"},
  {"code":"Carbamazepine"},
  {"code":"Carbocal"},
  {"code":"Carborite"},
  {"code":"Cardizem"},
  {"code":"Cardura"},
  {"code":"Carvedilol"},
  {"code":"Celebrex"},
  {"code":"Celecoxib"},
  {"code":"Celexa"},
  {"code":"CellCept"},
  {"code":"Centrum"},
  {"code":"Certirizine"},
  {"code":"Hyperbaric Chamber"},
  {"code":"Champix"},
  {"code":"Chlorothiazide"},
  {"code":"Cholesterol"},
  {"code":"Cholestide"},
  {"code":"Cialis"},
  {"code":"Cilazapril"},
  {"code":"Cipralex"},
  {"code":"Zyprexa"},
  {"code":"Citalopram"},
  {"code":"Citel"},
  {"code":"Claritin"},
  {"code":"Clindamycin"},
  {"code":"Clobazam"},
  {"code":"Clobetasol"},
  {"code":"Clonazepam"},
  {"code":"Clonidine"},
  {"code":"Clopidrogel"},
  {"code":"Clotrimaderm"},
  {"code":"Clozapine"},
  {"code":"Codeine"},
  {"code":"Colchicine"},
  {"code":"Comboglyc"},
  {"code":"Concentration"},
  {"code":"Concerta"},
  {"code":"Constella"},
  {"code":"Copaxone"},
  {"code":"Cordura"},
  {"code":"Corgard"},
  {"code":"Cortef"},
  {"code":"Cortico nasal"},
  {"code":"Cortisone"},
  {"code":"Cositra"},
  {"code":"Cotazyme"},
  {"code":"Coumadin"},
  {"code":"Coversyl"},
  {"code":"Cozaar"},
  {"code":"Creon"},
  {"code":"Crestor"},
  {"code":"Cyclobenzaprine"},
  {"code":"Cyclocapron"},
  {"code":"Cyclocort"},
  {"code":"Cymbalta"},
  {"code":"Depro provera"},
  {"code":"Desyrel"},
  {"code":"Desonide"},
  {"code":"Destrace"},
  {"code":"Detrol"},
  {"code":"Dexidrine"},
  {"code":"Dexilant"},
  {"code":"Diabenil"},
  {"code":"Diabeta"},
  {"code":"Diamicron"},
  {"code":"Diamox"},
  {"code":"Diane 35"},
  {"code":"Dianorm XR"},
  {"code":"Diazepam"},
  {"code":"Diazid"},
  {"code":"Dicetel"},
  {"code":"Dicletin"},
  {"code":"Diclofenac"},
  {"code":"Dilantin"},
  {"code":"Dilaudid"},
  {"code":"Diltiaz"},
  {"code":"Diltiazem"},
  {"code":"Diovan"},
  {"code":"Diovol"},
  {"code":"Ditropan"},
  {"code":"Diuretic"},
  {"code":"Divalproex"},
  {"code":"Diet pills"},
  {"code":"Docusate sodium"},
  {"code":"Domperidone"},
  {"code":"Donepezil"},
  {"code":"Dostinex"},
  {"code":"Doxazosin"},
  {"code":"Doxitab"},
  {"code":"Doxycycline"},
  {"code":"Drixoral"},
  {"code":"Duloxetine"},
  {"code":"Durela"},
  {"code":"Dutasteride"},
  {"code":"Dydrocal"},
  {"code":"Effexor"},
  {"code":"Effient"},
  {"code":"Elavil"},
  {"code":"Eliquis"},
  {"code":"Elmiron"},
  {"code":"Empracet"},
  {"code":"Emtec"},
  {"code":"Enalapril"},
  {"code":"Enbrel"},
  {"code":"Entacapone"},
  {"code":"Entocort"},
  {"code":"Entresto"},
  {"code":"Entrophen"},
  {"code":"Enzyme"},
  {"code":"Epipen"},
  {"code":"Epival"},
  {"code":"Esomeprazole"},
  {"code":"Estrace"},
  {"code":"Estradiol"},
  {"code":"Estradot"},
  {"code":"Estrogel"},
  {"code":"Euro folic"},
  {"code":"Euro senna"},
  {"code":"Evista"},
  {"code":"Exalto"},
  {"code":"Exelon"},
  {"code":"Exelon patch"},
  {"code":"Ezetimibe"},
  {"code":"Ezetrol"},
  {"code":"Fampyra"},
  {"code":"Femora"},
  {"code":"Fenofibrate"},
  {"code":"Fentanyl"},
  {"code":"Fibrastile"},
  {"code":"Fibristal"},
  {"code":"Filodopine"},
  {"code":"Finasteride"},
  {"code":"Fiorinal"},
  {"code":"Flexiril"},
  {"code":"Flomax"},
  {"code":"Flonase"},
  {"code":"Florinef"},
  {"code":"Flovent"},
  {"code":"Flovent/Ventolin"},
  {"code":"Fluoxetine"},
  {"code":"Fluvoxamine"},
  {"code":"Folic Acid"},
  {"code":"Forxiga"},
  {"code":"Fosamax"},
  {"code":"Fosavance"},
  {"code":"Fosinopril"},
  {"code":"Frisium"},
  {"code":"Frova"},
  {"code":"Furosemide"},
  {"code":"Gabapentin"},
  {"code":"Galantamine"},
  {"code":"Generic Cholesterol Pill"},
  {"code":"Genius"},
  {"code":"Gilenya"},
  {"code":"Gleevec"},
  {"code":"Glen lamotrigen"},
  {"code":"Gliclazide"},
  {"code":"Glimepiride"},
  {"code":"Glucobay"},
  {"code":"Gluconorm"},
  {"code":"Glucophage"},
  {"code":"Glucosamine"},
  {"code":"Glumetza"},
  {"code":"Glyburide"},
  {"code":"Gravol"},
  {"code":"Haldol"},
  {"code":"Heparin"},
  {"code":"Hormones"},
  {"code":"Humira"},
  {"code":"Hydrasense"},
  {"code":"Hydrea"},
  {"code":"Hydrochlorothiazide"},
  {"code":"Hydromorphone"},
  {"code":"Hydroxyquine"},
  {"code":"Hyzaar"},
  {"code":"Imdur"},
  {"code":"Imitrex"},
  {"code":"Immodium"},
  {"code":"Imovane"},
  {"code":"Imuran"},
  {"code":"Imurel"},
  {"code":"Incruse ellipta"},
  {"code":"Indapamine"},
  {"code":"Inderal"},
  {"code":"Inhibace plus"},
  {"code":"Inspra"},
  {"code":"Insulin"},
  {"code":"Intelence"},
  {"code":"Intuniv"},
  {"code":"Invokana"},
  {"code":"Irbesartan"},
  {"code":"Iron"},
  {"code":"Janumet"},
  {"code":"Januvia"},
  {"code":"Keppra"},
  {"code":"Lacmital"},
  {"code":"Lactaid"},
  {"code":"Lactudad"},
  {"code":"Lactulose"},
  {"code":"Lamotrigine"},
  {"code":"Lanoxin"},
  {"code":"Lansoprazole"},
  {"code":"Lantus"},
  {"code":"Latuda"},
  {"code":"Lectopan"},
  {"code":"Lescol"},
  {"code":"Letrozol"},
  {"code":"Levetiracetam"},
  {"code":"Levocarb"},
  {"code":"Levofloxacin"},
  {"code":"Levothyrox"},
  {"code":"Linessa"},
  {"code":"Lipidil"},
  {"code":"Lipitor"},
  {"code":"Lisinopril"},
  {"code":"Lithane"},
  {"code":"Lithium"},
  {"code":"Lodalisse"},
  {"code":"Lomotine"},
  {"code":"Loperamide"},
  {"code":"Lopressor"},
  {"code":"Loprox"},
  {"code":"Lorazepam"},
  {"code":"Losartan"},
  {"code":"Losec"},
  {"code":"Lozide"},
  {"code":"Lutein"},
  {"code":"Luvox"},
  {"code":"Lyrica"},
  {"code":"Maglucate"},
  {"code":"Magnesium"},
  {"code":"Marvelon"},
  {"code":"Materna"},
  {"code":"Mavik"},
  {"code":"Maxalt"},
  {"code":"Mcal"},
  {"code":"Mdet"},
  {"code":"Medrone"},
  {"code":"Melatonin"},
  {"code":"Meloxicam"},
  {"code":"Meperidine"},
  {"code":"Mesavant"},
  {"code":"Metadol"},
  {"code":"Metadone"},
  {"code":"Metformin"},
  {"code":"Metformin le prend +/-"},
  {"code":"Methotrexate"},
  {"code":"Methyl B9"},
  {"code":"Methyldopazepine"},
  {"code":"Methylphenidate"},
  {"code":"Metonia"},
  {"code":"Metoprolol"},
  {"code":"Metrogel"},
  {"code":"Metronidazole"},
  {"code":"Micardis"},
  {"code":"Micardis+"},
  {"code":"Micronor"},
  {"code":"Midodrine"},
  {"code":"Miniestrin"},
  {"code":"Minocin"},
  {"code":"Minocycline"},
  {"code":"Mirapex"},
  {"code":"Mirena"},
  {"code":"Mirtazapine"},
  {"code":"Mitriptiline"},
  {"code":"Modulon"},
  {"code":"Mogadon"},
  {"code":"Mometasone"},
  {"code":"Monitan"},
  {"code":"Monocor"},
  {"code":"Monopril"},
  {"code":"Montelukast"},
  {"code":"Morphine"},
  {"code":"Motilium"},
  {"code":"Motrin"},
  {"code":"MultiVitamin"},
  {"code":"Mylan bupropion"},
  {"code":"Myrbetriq"},
  {"code":"Mevacor"},
  {"code":"Nabilone"},
  {"code":"Naproxen"},
  {"code":"Nasacort"},
  {"code":"Nasonex"},
  {"code":"Neoral"},
  {"code":"Neurontin"},
  {"code":"Nexium"},
  {"code":"Niacin"},
  {"code":"Nifedipine"},
  {"code":"Nilotinib"},
  {"code":"Nitro"},
  {"code":"Nortryptyline"},
  {"code":"Norvasc"},
  {"code":"Novacor"},
  {"code":"Novasen"},
  {"code":"Novatech"},
  {"code":"Novo 5 asa"},
  {"code":"Novo clonidine"},
  {"code":"Novo triamzide"},
  {"code":"Novoalendronate"},
  {"code":"Novofine"},
  {"code":"Novoformil"},
  {"code":"Novoglyburide"},
  {"code":"Novohydrazide"},
  {"code":"Novokana"},
  {"code":"Novolin"},
  {"code":"Novomix"},
  {"code":"Novopranol"},
  {"code":"Novorapid"},
  {"code":"Novosemide"},
  {"code":"Nucynta"},
  {"code":"Ocuvite"},
  {"code":"Oestradiol"},
  {"code":"Oestrogel"},
  {"code":"Olmetec"},
  {"code":"Olmetec plus"},
  {"code":"Omega 3"},
  {"code":"Omega 3-6-9"},
  {"code":"Omeprazole"},
  {"code":"One-alpha"},
  {"code":"Onglyza"},
  {"code":"Opticrom"},
  {"code":"Otrivin"},
  {"code":"Oxazepam"},
  {"code":"Oxeze"},
  {"code":"Oxycodone"},
  {"code":"Oxybutynin"},
  {"code":"Oxycontin"},
  {"code":"Oxygen"},
  {"code":"Oxyse"},
  {"code":"Oxytrol"},
  {"code":"Palafer"},
  {"code":"Pantoloc"},
  {"code":"Pantoprazole"},
  {"code":"Paracetamol"},
  {"code":"Pariet"},
  {"code":"Paroxetine"},
  {"code":"Patch"},
  {"code":"Patch nicotine"},
  {"code":"Paxil"},
  {"code":"Penicillin"},
  {"code":"Penta B"},
  {"code":"Pentasa"},
  {"code":"Pepcid"},
  {"code":"Phenophybrate"},
  {"code":"Pill"},
  {"code":"Pindolol"},
  {"code":"Pioglitazone"},
  {"code":"Plaquenil"},
  {"code":"Plavix"},
  {"code":"Pms nabilone"},
  {"code":"Potassium"},
  {"code":"Pradax"},
  {"code":"Pramipexole"},
  {"code":"Pravachol"},
  {"code":"Pravastatin"},
  {"code":"Prednisone"},
  {"code":"Pregabalin"},
  {"code":"Premarin"},
  {"code":"Preservision"},
  {"code":"Prevacid"},
  {"code":"Prezista"},
  {"code":"Primetropine"},
  {"code":"Primidone"},
  {"code":"Prinivil"},
  {"code":"Pristiq"},
  {"code":"Pro ASA"},
  {"code":"Pro cal D"},
  {"code":"Pro fluoxetine"},
  {"code":"Pro ismn"},
  {"code":"Pro triazide"},
  {"code":"Pro-bisoprolol"},
  {"code":"Probiotic"},
  {"code":"Procet"},
  {"code":"Progesterone"},
  {"code":"Prograf"},
  {"code":"Prolia"},
  {"code":"Prometrium"},
  {"code":"Propanolol"},
  {"code":"Propaphenol"},
  {"code":"Propecia"},
  {"code":"Proscar"},
  {"code":"Protopic"},
  {"code":"Protrin df"},
  {"code":"Provastatin"},
  {"code":"Provera"},
  {"code":"Proxar"},
  {"code":"Prozac"},
  {"code":"Psoriatane"},
  {"code":"Pulmicort"},
  {"code":"Purinetol"},
  {"code":"Questran"},
  {"code":"Quetiapine"},
  {"code":"Quietipine"},
  {"code":"Quinapril"},
  {"code":"Quinine"},
  {"code":"Rabeprazole"},
  {"code":"Ralixifene"},
  {"code":"Ramipril"},
  {"code":"Ranitidine"},
  {"code":"Rapaflo"},
  {"code":"Rasilez"},
  {"code":"Reactine"},
  {"code":"Rebif"},
  {"code":"Relpax"},
  {"code":"Remeron"},
  {"code":"Remicad"},
  {"code":"Remzo"},
  {"code":"Renedil"},
  {"code":"Repaglinide"},
  {"code":"Rhotral"},
  {"code":"Rifampin"},
  {"code":"Rilutek"},
  {"code":"Risedronate"},
  {"code":"Risperdal"},
  {"code":"Ritalin"},
  {"code":"Rivasa"},
  {"code":"Rivotril"},
  {"code":"Robaxacet"},
  {"code":"Rosuvastatin"},
  {"code":"Reactine"},
  {"code":"Salbutamol"},
  {"code":"Salivex"},
  {"code":"Salofalk"},
  {"code":"Salvent"},
  {"code":"Secaris"},
  {"code":"Sectral"},
  {"code":"Seebri"},
  {"code":"Senna"},
  {"code":"Sennosides"},
  {"code":"Serevent"},
  {"code":"Serophen"},
  {"code":"Seroquel"},
  {"code":"Sertraline"},
  {"code":"Sialor"},
  {"code":"Silenor"},
  {"code":"Symbicort"},
  {"code":"Simvastatin"},
  {"code":"Singulair"},
  {"code":"Sinutab 1x/jour"},
  {"code":"Sleep-eze"},
  {"code":"Sleeping pills"},
  {"code":"Spiriva"},
  {"code":"Spironolactone"},
  {"code":"Stalevo"},
  {"code":"Stelara"},
  {"code":"Sterilet"},
  {"code":"Stevia"},
  {"code":"Stratera"},
  {"code":"Sublinox"},
  {"code":"Sucrate"},
  {"code":"Supeudol"},
  {"code":"Symbicort"},
  {"code":"Synthroid"},
  {"code":"Tamoxifen"},
  {"code":"Tamsulosin"},
  {"code":"Tapazole"},
  {"code":"Tecfidera"},
  {"code":"Tegretol"},
  {"code":"Telmisartan"},
  {"code":"Tenormin"},
  {"code":"Terasozin"},
  {"code":"Terbinafine"},
  {"code":"Teriflunamide"},
  {"code":"Testosterone"},
  {"code":"Tetra"},
  {"code":"Tetracycline"},
  {"code":"Teva clobazam"},
  {"code":"Teva-pravastatin"},
  {"code":"Tevavalafaxine"},
  {"code":"Teveten"},
  {"code":"Tiazac xc"},
  {"code":"Ticlopidine"},
  {"code":"Tintrellix"},
  {"code":"Toctino"},
  {"code":"Toloxin"},
  {"code":"Topamax"},
  {"code":"Topilene"},
  {"code":"Topiramate"},
  {"code":"Topisone"},
  {"code":"Toviaz"},
  {"code":"Tradjenta"},
  {"code":"Tramacet"},
  {"code":"Tramadol"},
  {"code":"Trandate"},
  {"code":"Trazodone"},
  {"code":"Tridural"},
  {"code":"Trileptal"},
  {"code":"Trintelix"},
  {"code":"Triptans"},
  {"code":"Triquilar"},
  {"code":"Trosec"},
  {"code":"Trulicity"},
  {"code":"Truvada"},
  {"code":"Tudorza"},
  {"code":"Twinta"},
  {"code":"Tylenol"},
  {"code":"Tylenol arthritis"},
  {"code":"Tylenol codeine"},
  {"code":"Tylenol muscular"},
  {"code":"Tysabri"},
  {"code":"Urso"},
  {"code":"Vagifem"},
  {"code":"Valacyclovir"},
  {"code":"Valium"},
  {"code":"Valproic acid"},
  {"code":"Valsartan"},
  {"code":"Valtrex"},
  {"code":"Vasotec"},
  {"code":"Venlafaxine"},
  {"code":"Ventolin"},
  {"code":"Verapamil"},
  {"code":"Vesicare"},
  {"code":"Vessie"},
  {"code":"Viagra"},
  {"code":"Victoza"},
  {"code":"Videx"},
  {"code":"Vimovo"},
  {"code":"Vioxx"},
  {"code":"Viread"},
  {"code":"Vitamin B1"},
  {"code":"Vitamin B6"},
  {"code":"Vitamin B12"},
  {"code":"Vitamin C"},
  {"code":"Vitamin D"},
  {"code":"Vitamin E"},
  {"code":"Vitalux"},
  {"code":"Vitalux S"},
  {"code":"Vitalux areds lutein"},
  {"code":"Voltaren"},
  {"code":"Vyvanse"},
  {"code":"Warfarin"},
  {"code":"Wellbutrin"},
  {"code":"Winpred"},
  {"code":"Xanax"},
  {"code":"Xarelto"},
  {"code":"Xatral"},
  {"code":"Xenical"},
  {"code":"Yasmine"},
  {"code":"Zantac"},
  {"code":"Zeldox"},
  {"code":"Zenhale"},
  {"code":"Zestril"},
  {"code":"Zezonique"},
  {"code":"Zinc"},
  {"code":"Zocor"},
  {"code":"Zoloft"},
  {"code":"Zomig"},
  {"code":"Zopiclone"},
  {"code":"Zyban"},
  {"code":"Zyloprim"},
  {"code":"Zytiga"}
]
